import Story from 'umg-ember-backend/components/record-explorer/for/story';

<template><Story @records={{@model}} @recordType='story' /></template>
